import {
  Box,
  Typography,
  Grid,
  ToggleButtonGroup,
  ToggleButton,
  Alert,
} from "@mui/material";
import { CreateStepperRaffleProps } from "../../../../domain/CreateStepperRaffleProps";
import { DeviceFrameset } from "react-device-frameset";
import 'react-device-frameset/styles/marvel-devices.min.css';

import { ActiveRaffle2 } from "../../../home/ActiveRaffle2";
import { ActiveRaffle } from "../../../home/ActiveRaffle";

const TEMPLATE_OPTIONS = [
  { id: 'default', label: '🎯 Clásica' },
  { id: 'template1', label: '🚀 Moderna' },
];

export const SummaryRaffleStep = ({ resource, setResource }: CreateStepperRaffleProps) => {
  const currentTemplateId = resource?.templateId || 'template1';

  const handleTemplateChange = (_: any, newTemplateId: string | null) => {
    if (newTemplateId) {
      setResource({ ...resource, templateId: newTemplateId });
    }
  };

  const renderPreviewComponent = () => {
    switch (currentTemplateId) {
      case 'default':
        return <ActiveRaffle activeRaffle={resource as any} isPreview />;
      case 'template1':
        return <ActiveRaffle2 activeRaffle={resource as any} isPreview />;
      default:
        return;
    }
  };

  return (
    <Box paddingTop={4}>
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          md={3}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
            Elige el estilo de tu rifa
          </Typography>

          <ToggleButtonGroup
            value={currentTemplateId}
            exclusive
            onChange={handleTemplateChange}
            orientation="vertical"
            size="medium"
            sx={{
              borderRadius: 2,
              mt: 2,
            }}
          >
            {TEMPLATE_OPTIONS.map((option) => (
              <ToggleButton
                key={option.id}
                value={option.id}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  py: 1,
                  px: 3,
                }}
              >
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Grid>

        {/* Columna central */}
        <Grid item xs={12} md={6} display="flex" justifyContent="center">
          <DeviceFrameset device="iPhone X">
            <div
              style={{
                height: '820px',
                overflowY: 'scroll',
                position: 'relative',
              }}
            >
              {renderPreviewComponent()}
            </div>
          </DeviceFrameset>
        </Grid>

        {/* Columna derecha */}
        <Grid
          item
          xs={12}
          md={3}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            ¿Todo listo? 🎟️
          </Typography>
          <Typography variant="body1">
            Revisa cómo se verá tu rifa en dispositivos móviles. Si estás conforme, dale click al botón CREAR RIFA.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
